import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import { Colors } from "utils/colors";

export const StyledToastContainer = styled(ToastContainer)`
  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  &&&.Toastify__toast-container {
  }
  .Toastify__toast {
    background-color: ${Colors.grey700};
  }
  .Toastify__toast-body {
    font-size: 1.4rem;
    font-family: "Switzer", sans-serif;
  }
  .Toastify__progress-bar {
  }
  .Toastify__toast-theme--colored.Toastify__toast--error {
    color: ${Colors.danger};
  }
  .Toastify__toast-theme--colored.Toastify__toast--success {
    color: ${Colors.success};
  }
  .Toastify__toast-theme--colored.Toastify__toast--warning {
    color: ${Colors.yellow500};
  }
  .Toastify__close-button {
    margin-top: auto;
    margin-bottom: auto;
  }
`;
